//Import React
import React, { useContext, useEffect, useState } from "react";
import Select, { components } from "react-select";
import { useLocation } from "react-router-dom";
//Import Contexts
import { AppContext } from "../../contexts/AppContext";
import staticData from '../../contexts/staticData.json';
//Import Helpers
import { formatCurrency, formatDisplayName, getSubventionNames, getTypePurchase } from "../../shared/helpers";
//Import Components
import ViewPaymentRequest from "./ViewPaymentRequest";
import MessageConfirmation from "../messageConfirmation/MessageConfirmation";
//Import Icons
import historyIcon from '../../assets/icons/history.svg';
import filters from '../../assets/icons/filters.svg';
import docIcon from '../../assets/icons/document.svg';
import wallet from '../../assets/icons/walletWhite.svg';
import warning from '../../assets/icons/infoWhite.svg';
//Import CSS
import './viewPendingPayment.css';

function ViewPendingPaymentRequest({ setView, pendingRequests, userData, establishmentList, pmeList, data, selectedRequest, setSelectedRequest, view, viewObserved, viewRejected }) {
    const location = useLocation();
    const { requestsList, globalNotifications, showNotification } = useContext(AppContext);
    const [typeOfRequest, setTypeOfRequest] = useState({ value: 'all', label: 'Todas las solicitudes' });
    const [filteredRequests, setFilteredRequests] = useState([]);
    const [viewRequest, setViewRequest] = useState(location.state?.viewRequest || false);
    const [confirmation, setConfirmation] = useState(false);

    useEffect(() => {
        const contenedor = document.querySelector('.payment-request'); // o tu clase principal scrollable
        if (contenedor) contenedor.scrollTop = 0;
    }, []);

    useEffect(() => {
        filterRequests();
    }, [typeOfRequest, pendingRequests]);

    const filterRequests = () => {
        let filtered = pendingRequests || [];
        if (typeOfRequest.value !== 'all') {
            filtered = pendingRequests?.filter(request => request.typeOfRequest === typeOfRequest.value);
        }
        setFilteredRequests(filtered);
    };

    const getActivityDetails = (idPME, idActivity) => {
        const pme = pmeList.find(pme => pme.id === idPME);
        if (pme) {
            const activity = pme.activities.find(act => act.id === idActivity);
            if (activity) {
                return {
                    actionName: activity.nameOfAction,
                    subvention: activity.subsidies,
                    pmeAmount: activity.totalSubsidyAmount,
                    fullActivity: activity
                };
            }

        }
        return { actionName: 'No encontrado', subvention: 'No encontrado', pmeAmount: 'No encontrado', fullActivity: null };
    };

    const getDocumentUrl = (request) => {
        if (request.typeOfRequest === 'payment') {
            const originalRequest = requestsList.find(req => req.id === request.originRequestId);
            return originalRequest?.history[originalRequest.history.length - 1]?.backups[0]?.url;
        } else {
            return request?.history[request.history.length - 1]?.backups[0]?.url;
        }
    };

    const handleRequestSelection = (request) => {
        setSelectedRequest(prevSelected => {
            if (prevSelected === undefined) return request;
            return prevSelected && prevSelected.id === request.id ? null : request;
        });
    };

    const handleClickBack = () => {
        setView(false);
    };

    const handleClosePaymentRequest = (succes) => {
        setViewRequest(false);
        if (succes) {
            showNotification('addPaymentRequest', true)
            setSelectedRequest(null);
        }
    }

    return (
        <section className={`view-pending-payment-request flex ${viewRequest ? 'request-open' : ''}`}>
            <article className='request-pending'>
                <span className='filter-box flex'>
                    <button className='button-payment-history flex'>
                        <img src={historyIcon} className='icon' alt='Icono Historial Solicitudes de Pago' />
                        <p>Ver Historial de Solicitudes de Pago</p>
                    </button>
                    {!viewRejected && ( // Solo mostrar el filtro si no estamos en vista de rechazadas
                        <span className='input-select flex'>
                            <label htmlFor='typeOfRequest' className='hidden-label'>Filtrar por Tipo de Solicitud</label>
                            <Select
                                name='typeOfRequest'
                                id='typeOfRequest'
                                options={staticData.typeOfRequestOptions}
                                placeholder='Selecciona tipo de solicitud'
                                className='custom-select'
                                classNamePrefix='custom-select'
                                components={{ DropdownIndicator }}
                                onChange={(selectedOption) => setTypeOfRequest(selectedOption)}
                                value={typeOfRequest}
                            />
                        </span>
                    )}
                </span>
                <table>
                    <thead>
                        <tr>
                            <th>Sel</th>
                            <th>Tipo de Solicitud</th>
                            <th>Nombre de la Acción</th>
                            <th>Subvención</th>
                            <th>Monto Solicitud</th>
                            {viewRejected && <th>Tipo de Pago</th>}
                            <th>Aceptado por</th>
                            <th>Monto O.C / Contrato</th>
                            <th>Ver O.C / Contratos</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredRequests?.length > 0 ? (
                            filteredRequests
                                .slice()
                                .sort((a, b) => {
                                    // Verificar si es una solicitud de tipo 'payment' y acceder a la propiedad correspondiente
                                    const createdDateA = a.typeOfRequest === 'payment' ? a.created : a.requestDetails.created;
                                    const createdDateB = b.typeOfRequest === 'payment' ? b.created : b.requestDetails.created;
                                    return createdDateB - createdDateA; // Orden descendente (más reciente primero)
                                })
                                .map((request) => {
                                    const { actionName, subvention } = getActivityDetails(request.idPME, request.idActivity);
                                    const documentUrl = getDocumentUrl(request);
                                    return (
                                        <tr key={request.id}>
                                            <td data-label='Selección'>
                                                <label className='custom-checkbox' >
                                                    <input
                                                        type='checkbox'
                                                        checked={selectedRequest !== undefined && selectedRequest !== null && selectedRequest.id === request.id}
                                                        onChange={() => handleRequestSelection(request)}
                                                    />
                                                    <span className='checkmark'></span>
                                                </label>
                                            </td>
                                            <td data-label='Tipo de Solicitud'>{getTypePurchase(request?.typeOfRequest)}</td>
                                            <td data-label='Nombre de la Acción'>{formatDisplayName(actionName)}</td>
                                            <td data-label='Subvención'>{getSubventionNames(subvention)}</td>
                                            <td data-label='Monto Solicitud'>{request.typeOfRequest === 'payment'
                                                ? formatCurrency(requestsList.find(req => req.id === request.originRequestId)?.requestDetails?.requestAmount)
                                                : formatCurrency(request.requestDetails?.requestAmount)}
                                            </td>
                                            {viewRejected && (
                                                <td data-label='Tipo de Pago'>{request.paymentType?.label || 'N/A'}</td>
                                            )}
                                            <td data-label='Aceptado por'>
                                                {request?.history[request.history.length - 1].responsibleName}
                                                <br />
                                                <strong>{request?.history[request.history.length - 1].role}</strong>
                                            </td>
                                            <td data-label='Monto O.C / Contrato'>{request.typeOfRequest === 'payment'
                                                ? formatCurrency(request?.purchaseOrderAmount)
                                                : formatCurrency(request.requestDetails?.purchaseOrderAmount)}
                                            </td>
                                            <td data-label='Ver O.C / Contratos'>
                                                {documentUrl ? (
                                                    <a href={documentUrl} target='_blank' rel='noopener noreferrer'>
                                                        <img src={docIcon} className='icon' alt='Icono para ver O.C / Contrato.' />
                                                    </a>
                                                ) : (<span>No disponible</span>)}
                                            </td>
                                        </tr>
                                    );
                                })
                        ) : (
                            <tr>
                                <td colSpan='8'>No Existen Solicitudes</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </article>
            <article className={`box-actions flex ${!selectedRequest ? 'disabled' : ''}`}>
                <button
                    className={`button-created flex ${!selectedRequest ? 'disabled' : ''}`}
                    disabled={!selectedRequest ? true : false}
                    onClick={() => setViewRequest(true)}
                >
                    <img src={wallet} className='icon' alt='Icono de Crear Solicitud de Pago' />
                    <p>{viewRejected ? 'Crear Nueva Solicitud de Pago' : 'Crear Solicitud de Pago'}</p>
                </button>
                <button className='button-back flex' type='button' onClick={handleClickBack}>
                    <p>Volver</p>
                </button>
                <span className={`tooltip-message flex ${!selectedRequest ? 'show' : ''}`}>
                    <img src={warning} alt='Icono de adevertencia botón deshabilitado' />
                    <p>Debes seleccionar una solicitud</p>
                </span>
            </article>
            {viewRequest && (
                <ViewPaymentRequest
                    request={selectedRequest}
                    establishmentList={establishmentList}
                    pmeList={pmeList}
                    userData={userData}
                    viewRequest={viewRequest}
                    setView={handleClosePaymentRequest}
                    data={data}
                    view={view}
                    viewObserved={viewObserved}
                    viewRejected={viewRejected}
                />
            )}
            <MessageConfirmation confirmation={globalNotifications.addPaymentRequest} view={true} />
        </section>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={filters} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default ViewPendingPaymentRequest;